export enum AuthenticationType {
  REMEMBER_ME = 1, // one-based not to have a falsy value
  SSO = 2,
  RECONNECT = 3,
  TICKET = 4
}

export const SuccessEvents = {
  [AuthenticationType.REMEMBER_ME]: 'RememberMeSuccess',
  [AuthenticationType.SSO]: 'SSOLoginSuccess',
  [AuthenticationType.TICKET]: 'TicketLoginSuccess'
};

export const FailureEvents = {
  [AuthenticationType.REMEMBER_ME]: 'remember me connect',
  [AuthenticationType.SSO]: 'sso connect',
  [AuthenticationType.RECONNECT]: 'reconnect',
  [AuthenticationType.TICKET]: 'ticket'
};
